var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverdue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98.393,
    height: 94.428,
    viewBox: "0 0 98.393 94.428",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2765",
    "data-name": "Group 2765",
    transform: "translate(-691.027 -5878.572)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2764",
    "data-name": "Group 2764"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1222",
    "data-name": "Group 1222"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1219",
    "data-name": "Group 1219"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_933",
    "data-name": "Path 933",
    d: "M720.853,5925.5v-46.33h67.97v86.507H754.341",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1215",
    "data-name": "Group 1215"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_934",
    "data-name": "Path 934",
    d: "M748.341,5956.17h31.743v-29.627H729.591",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1031",
    "data-name": "Line 1031",
    x2: 44.243,
    transform: "translate(735.841 5936.418)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1032",
    "data-name": "Line 1032",
    y2: 29.74,
    transform: "translate(769.457 5926.543)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1033",
    "data-name": "Line 1033",
    y2: 29.74,
    transform: "translate(759.747 5926.543)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1034",
    "data-name": "Line 1034",
    y2: 17.457,
    transform: "translate(740.327 5926.543)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1218",
    "data-name": "Group 1218"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1216",
    "data-name": "Group 1216"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_935",
    "data-name": "Path 935",
    d: "M730.122,5913.226a50.85,50.85,0,0,0,10.773,1.618c4.714,0,9.427-3.015,9.427-6.733s-6.6-6.061-9.427-6.734-9.427-3.015-9.427-6.734,4.714-6.733,9.427-6.733a74.744,74.744,0,0,1,10.774,1.076",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1035",
    "data-name": "Line 1035",
    x2: 0.133,
    y2: 36.765,
    transform: "translate(740.895 5883.599)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1217",
    "data-name": "Group 1217"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1036",
    "data-name": "Line 1036",
    x2: 24.981,
    transform: "translate(756.633 5886.277)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1037",
    "data-name": "Line 1037",
    x2: 24.981,
    transform: "translate(756.633 5896.163)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1038",
    "data-name": "Line 1038",
    x2: 24.981,
    transform: "translate(756.633 5906.049)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1039",
    "data-name": "Line 1039",
    x2: 24.981,
    transform: "translate(756.633 5915.935)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1221",
    "data-name": "Group 1221"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_936",
    "data-name": "Path 936",
    d: "M758.841,5973l-33.917-53.812-33.9,53.792Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1220",
    "data-name": "Group 1220"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_937",
    "data-name": "Path 937",
    d: "M723.748,5957.693l-1.154-16.312v-6.822h4.681v6.822l-1.091,16.312Zm-.986,7.641v-4.3h4.345v4.3Z",
    fill: "#fff"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverdue);
export default __webpack_public_path__ + "static/media/overdue.cae1c7da4d66282290e49c44a3a46fc4.svg";
export { ForwardRef as ReactComponent };